import { render } from "./DialogMsg.vue?vue&type=template&id=8c1534fe&scoped=true"
import script from "./DialogMsg.vue?vue&type=script&lang=js"
export * from "./DialogMsg.vue?vue&type=script&lang=js"

import "./DialogMsg.vue?vue&type=style&index=0&id=8c1534fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c1534fe"]])

export default __exports__